/* 🤖 this file was generated by svg-to-ts */
export const iconRemove: {
    name: 'remove';
    data: string;
} = {
    name: 'remove',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="2" viewBox="0 0 18 2"><path fill="#000" fill-rule="evenodd" d="M17 .307a.693.693 0 0 1 .094 1.38L17 1.693H1A.693.693 0 0 1 .906.313L1 .307z"/></svg>`
};
